export const convertToRawDate = (date) => {
  let _date;

  if (date instanceof Date) {
    _date = date;
  } else if (typeof date === "number") {
    _date = new Date(date);
  } else if (typeof date === "string") {
    _date = new Date(date);
  } else {
    return null;
  }

  if (isNaN(_date.getTime())) {
    throw new Error("Invalid date value");
  }

  const year = _date.getFullYear();
  const month = String(_date.getMonth() + 1).padStart(2, "0");
  const day = String(_date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
